import { useQuery } from '@apollo/client';

import {
  GetToolboxTagsDocument,
  GetToolboxTagsQueryVariables,
} from './getToolboxTags.gql';

const useGetToolboxTags = (type: GetToolboxTagsQueryVariables['type']) => {
  const { data, ...hook } = useQuery(GetToolboxTagsDocument, {
    variables: { type },
  });

  const items = data?.toolboxTags;

  return {
    ...hook,
    items,
  };
};

export default useGetToolboxTags;
